import api from './api';

export const branchService = {
  getBranches: (params) => api.get('/vendors/branches/', { params }),
  getBranch: (branchId) => api.get(`/vendors/branches/${branchId}/`),
  createBranch: (data) => api.post('/vendors/branches/', data),
  updateBranch: (branchId, data) => api.put(`/vendors/branches/${branchId}/`, data),
  deleteBranch: (branchId) => api.delete(`/vendors/branches/${branchId}/`),
  toggleBranchStatus: (branchId) => api.patch(`/vendors/branches/${branchId}/toggle-status/`),
};
